export default __webpack_public_path__ + "static/media/airdockz-cbb-2.ce50da9d.png";